// @flow
import React, { Component, Fragment } from 'react';
import type { State } from 'store';
import { connect } from 'react-redux';
import PartnerComments from 'components/partner/PartnerComments/PartnerComments';
import PartnerCommentInput from 'components/partner/PartnerCommentInput/PartnerCommentInput';
import { PartnersActions } from 'store/actionCreators';
import type { Comment, RemoveComment, SubCommentsMap } from 'store/modules/partners';
import QuestionModal from 'components/common/QuestionModal';
import { type ContextRouter, withRouter } from 'react-router-dom';

type Props = {
  partnerId: ?string,
  comments: ?(Comment[]),
  subCommentsMap: SubCommentsMap,
  shouldCancel: boolean,
  logged: boolean,
  loading: boolean,
  username: ?string,
  removeComment: RemoveComment,
  commentsCount: ?number,
} & ContextRouter;

class PartnerCommentsContainer extends Component<Props> {
  onOpenRemove = (payload: { commentId: string, parentId: ?string }) => {
    PartnersActions.openCommentRemove(payload);
  };

  onCancelRemove = () => {
    PartnersActions.cancelCommentRemove();
  };

  onConfirmRemove = () => {
    const { partnerId, removeComment } = this.props;
    if (!partnerId || !removeComment.commentId) return;
    PartnersActions.removeComment({
      partnerId,
      commentId: removeComment.commentId,
    });
  };

  onEditComment = ({
    commentId,
    parentId,
    text,
  }: {
    commentId: string,
    parentId: ?string,
    text: string,
  }) => {
    const { partnerId } = this.props;
    if (!partnerId) return Promise.resolve();
    return PartnersActions.editComment({
      partnerId,
      commentId,
      text,
      parentId,
    });
  };

  onWriteComment = async (text: string, replyTo: ?string, parentId?: ?string) => {
    const { partnerId } = this.props;
    if (!partnerId) return Promise.resolve();
    let comment = null;
    try {
      comment = await PartnersActions.writeComment({
        partnerId,
        text,
        replyTo,
      });
      if (replyTo) {
        await this.onReadReplies(replyTo, parentId);
      } else {
        await PartnersActions.readComments({ partnerId });
      }
    } catch (e) {
      console.log(e);
    }
    return comment;
  };

  initialize = async () => {
    const { partnerId, shouldCancel } = this.props;
    if (!partnerId) return;
    try {
      if (shouldCancel) return;
      await PartnersActions.readComments({ partnerId });
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.partnerId !== this.props.partnerId) {
      this.initialize();
    }
  }

  onReadReplies = (commentId: string, parentId?: ?string) => {
    const { partnerId } = this.props;
    if (!partnerId) return Promise.resolve(null);
    return PartnersActions.readSubComments({
      partnerId,
      commentId,
      parentId,
    });
  };

  render() {
    const {
      comments,
      subCommentsMap,
      logged,
      loading,
      username,
      removeComment,
      commentsCount,
    } = this.props;

    if (loading) return null;

    return (
      <Fragment>
        <PartnerComments
          logged={logged}
          commentInput={logged && <PartnerCommentInput onWriteComment={this.onWriteComment} />}
          comments={comments}
          subCommentsMap={subCommentsMap}
          onReply={this.onWriteComment}
          onReadReplies={this.onReadReplies}
          username={username}
          onOpenRemove={this.onOpenRemove}
          onEditComment={this.onEditComment}
          commentsCount={commentsCount || 0}
          currentPath={this.props.location.pathname}
        />
        <QuestionModal
          title="파트너 댓글 삭제"
          description="이 파트너 댓글을 정말로 삭제하시겠습니까?"
          confirmText="삭제하기"
          onConfirm={this.onConfirmRemove}
          onCancel={this.onCancelRemove}
          open={removeComment.visible}
        />
      </Fragment>
    );
  }
}

export default connect(
  (state: State) => ({
    logged: !!state.user.user,
    partnerId: state.partners.partner && state.partners.partner.id,
    comments: state.partners.comments,
    subCommentsMap: state.partners.subCommentsMap,
    shouldCancel: state.common.ssr && !state.common.router.altered,
    loading: !state.partners.partner || state.pender.pending['partners/READ_COMMENTS'],
    username: state.user.user && state.user.user.username,
    removeComment: state.partners.removeComment,
    commentsCount: state.partners.partner && state.partners.partner.comments_count,
  }),
  () => ({}),
)(withRouter(PartnerCommentsContainer));



// WEBPACK FOOTER //
// ./src/containers/partner/PartnerCommentsContainer.js